export default "__VITE_ASSET__CHW_a5Ry__"